module.exports = __webpack_public_path__ + "images/y-butin-3443b8.jpg";